/* eslint-disable */
export default {
  copy: 'Text',
} as const;

// @key: @#@"copy"@#@ @source: @#@"Copy"@#@
